import { isEmpty } from '@ember/utils';
export const chequeNoValidations = [
  {
    message: 'Cheque number must only contain 1-10 digits',
    validate: (inputValue) => /^\d{1,10}$/.test(inputValue),
  },
];
export const chequeBSBValidations = [
  {
    message: 'Cheque BSB must be in the form XXX-XXX, where X is a digit',
    validate: (inputValue) => /^\d{3}-\d{3}$/.test(inputValue),
  },
];
export const chequeAccountNoValidations = [
  {
    message: 'Cheque account number must only contain 1-9 digits',
    validate: (inputValue) => /^\d{1,9}$/.test(inputValue),
  },
];

export const moneyOrderNumberValidations = [
  {
    message: 'Must only contain numbers and dashes',
    validate: (inputValue) => /^[0-9-]+$/.test(inputValue),
  },
];

export const moneyOrderTextValidations = [
  {
    message: 'Must only contain letters, spaces, dashes and apostrophes',
    validate: (inputValue) => /^[A-Za-z-' ]+$/.test(inputValue),
  },
  {
    message: 'Must not consist solely of spaces',
    validate: (inputValue) => !/^\s+$/.test(inputValue),
  },
];

// conformAmount conforms a decimal amount as the user types.
export function conformAmount(amount) {
  return amount.replace(/[^\d.]/g, '');
}

// conformCount conforms an integer count as the user types.
export function conformCount(count) {
  let newCount = parseInt(count, 10);
  if (isEmpty(count) || isNaN(newCount)) {
    newCount = 0;
  }
  return newCount;
}

// formatAmount formats a currency amount to 2dp, or an empty string if no
// non-zero amount is specified.
export function formatAmount(amount) {
  if (isEmpty(amount)) {
    return '';
  } else {
    return parseFloat(amount).toFixed(2);
  }
}

// sumDiscrepancies totals the discrepancies' amounts, only those paid by
// `method` when one is given.
export function sumDiscrepancies(discrepancies, method) {
  let total = 0;
  for (let discrepancy of discrepancies) {
    if (method === undefined || discrepancy.method === method) {
      total += discrepancy.amount;
    }
  }
  return total;
}
